import React, {FC, Fragment} from 'react';
import Preloader from "../Preloader";

interface IWrapperPreloader {
    isLoading: boolean,
    heightPreloader?: string,
    children: JSX.Element
}

const WrapperPreloader: FC<IWrapperPreloader> = ({
                                                     isLoading,
                                                     children,
                                                     heightPreloader
                                                 }) => {

    return (
        <Fragment>
            {
                isLoading
                    ? <Preloader
                        height={heightPreloader}
                        />
                    : children
            }
        </Fragment>
    )
};

export default WrapperPreloader;
